export const isEnabledField = (fields?: FieldDto[], fieldName?: string): boolean => {
    if (!fields || !fieldName) {
        return false
    }

    const field = fields.find((x) => x.api_name === fieldName)
    return !!(field && !field.connection_options?.is_disabled)
}
